var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 52,
    height: 36,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 48h28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 44v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 44v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16v6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 34h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 38h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 31V20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 31V24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31V16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 31V22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.890e7407b488e9b4980413ceb61e2548.svg";
export { ForwardRef as ReactComponent };